export const commonApi = {
    // 初始化信息
    uploadImg: {
      method: 'post',
      api: 'admin/common/uploadImg',
    }
  }
  